/**
 * German labels for the shop's protocol values.
 *
 * The plugin sends locale-neutral type keys and message codes with an English
 * fallback text. The demo owns its language, so it maps them here instead of
 * relying on the shop to be German (L01).
 */

const TOTAL_LABELS: Record<string, string> = {
  subtotal: 'Zwischensumme',
  fulfillment: 'Versand',
  shipping: 'Versand',
  tax: 'enthaltene MwSt.',
  discount: 'Rabatt',
  total: 'Gesamt',
};

const MESSAGE_TEXTS: Record<string, string> = {
  cart_empty: 'Es liegen noch keine Produkte im Warenkorb.',
  buyer_required: 'Für den Abschluss werden Käufer- und Lieferdaten benötigt.',
  payment_pending: 'Die Testzahlung steht noch aus und erfordert eventuell eine weitere Eingabe.',
  payment_authorized_not_captured:
    'Die Zahlung ist autorisiert, aber noch nicht eingezogen. Es entsteht noch keine Bestellung.',
  payment_failed: 'Die Testzahlung wurde nicht abgeschlossen. Es entstand keine Bestellung.',
  'product-out-of-stock': 'Ein Artikel ist nicht mehr in der gewünschten Menge verfügbar.',
  'product-stock-reached': 'Für einen Artikel ist die verfügbare Menge erreicht.',
  'min-order-quantity': 'Für einen Artikel gilt eine Mindestbestellmenge.',
};

/** Falls back to the shop's own text when a key is unknown. */
export const totalLabel = (type: string, fallback: string): string =>
  TOTAL_LABELS[type] ?? fallback;

export const messageText = (code: string | undefined, fallback: string): string =>
  (code && MESSAGE_TEXTS[code]) || fallback;
